import validator from 'validator';

/**
 * Validates a given URL string.
 * Ensures the URL has a valid protocol and is properly formatted.
 *
 * @param {string} url - The URL string to validate.
 * @returns {boolean} - Returns true if the URL is valid, otherwise false.
 */
export const validateURL = ( url ) => {
    if (!validator.isURL(url, { require_protocol: true })) return false;

    try {
        const { protocol } = new URL(url);
        return protocol === 'https:' || protocol === 'http:';
    } catch {
        return false;
    }
} 

/**
 * Validates a form field containing a URL.
 * Updates the error message and field styles based on the validation result.
 *
 * @param {HTMLInputElement} field - The input field to validate.
 * @returns {boolean} - Returns true if the field value is valid or not required, otherwise false.
 */
export const validateField = (field) => {
    const errorMessage = field.parentElement.querySelector('.error-message');
    const urlValue = field.value.trim();

    if (!field.required && urlValue === '') {
        if (errorMessage) errorMessage.style.display = 'none';
        field.classList.remove('error-field');
        return true;
    }

    if (validateURL(urlValue)) {
        if (errorMessage) errorMessage.style.display = 'none';
        field.classList.remove('error-field');
        return true;
    }
    if (errorMessage) errorMessage.style.display = 'block';
    field.classList.add('error-field');
    return false;
};
